<template>
  <div class="commonDialogBody">
           <OrganizationalStructure @AllData="getMsgFormSon" style="display:none" />
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="50%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div style="width:70%;margin-left:5%;">
<el-form :label-position="labelPosition" label-width="100px" :model="formLabelAlign" style="width:75%;" >
  <el-form-item :label="formLabelAlign.obj.typeNum">
    <el-input v-model="formLabelAlign.typeNum" size="small"></el-input>
  </el-form-item>
    <el-form-item :label="formLabelAlign.obj.name" >
       <el-input v-model="formLabelAlign.name" size="small"></el-input>
    </el-form-item>
      <el-form-item :label="formLabelAlign.obj.isFixed" >
    <el-select  clearable v-model="isFixedval" placeholder="请选择定额票据"  size="small" @change="ChargeisFixed" >
        <el-option v-for="item in isFixed" :key="item.isFixedval" :label="item.isFixedlab" :value="item.isFixedval"></el-option>
    </el-select>
  </el-form-item>
     <el-form-item :label="formLabelAlign.obj.paperSpecies" >
    <el-select  clearable v-model="paperSpeciesval" placeholder="请选择票据种类"  size="small" @change="ChargepaperSpecies" >
        <el-option v-for="item in paperSpecies" :key="item.paperSpeciesval" :label="item.paperSpecieslab" :value="item.paperSpeciesval"></el-option>
    </el-select>
  </el-form-item>
    <el-form-item :label="formLabelAlign.obj.maxMoney" >
     <el-input v-model="formLabelAlign.maxMoney" size="small"></el-input>
    </el-form-item>
      <el-form-item :label="formLabelAlign.obj.everyNum" >
     <el-input v-model="formLabelAlign.everyNum" size="small"></el-input>
    </el-form-item>
    <el-form-item :label="formLabelAlign.obj.remarks" >
     <el-input v-model="formLabelAlign.remarks" size="small"></el-input>
    </el-form-item>
</el-form>
</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import OrganizationalStructure from "../common/OrganizationalStructure.vue";
export default {
 components: {OrganizationalStructure},
  name: "BillSetDialog",
  //  props:['formLabelAlign'],
  data() {
    return {
    options:[],
     value:"",
     isFixed:[{
         isFixedval:"0",
         isFixedlab:"否",
     },{
         isFixedval:"1",
         isFixedlab:"是",
     }],
     isFixedval:"",

       paperSpecies:[{
         paperSpeciesval:"1",
         paperSpecieslab:"发票",
     },{
         paperSpeciesval:"2",
         paperSpecieslab:"收据",
     }],
     paperSpeciesval:"",


     optionsone: [],
        valueone: '',
        dialogVisible: false,
     title:"标题",
     labelPosition:'right',
     formLabelAlign:{},
     type:"",
     display:"",
     detection:"",
     UserDisplay:"",
    };
  },
  methods: {
      ChargeisFixed(){
          // console.log(this.isFixedval)
      },
        ChargepaperSpecies(){
          // console.log(this.paperSpeciesval)
      },
      handleChange(value){
          //  console.log(value);
      },
      TenementType(value){
          // console.log(value)
          for(let val of this.options){
              if(value == val.value){
                  // console.log(val.subjectsName,val.subjectsCode)
                  this.formLabelAlign.displayName = val.subjectsName
                  this.formLabelAlign.subjectsName = val.subjectsCode
              }
          }
      },
    modification(){
        if(this.title == "修改"){
          this.dialogVisible = false
          let obj = {
              "id":this.formLabelAlign.id,
              "typeNum":this.formLabelAlign.typeNum,
              "name":this.formLabelAlign.name,
              "isFixed":this.isFixedval,
              "paperSpecies":this.paperSpeciesval,
              "everyNum":this.formLabelAlign.everyNum,
              "maxMoney":this.formLabelAlign.maxMoney,
              "remarks":this.formLabelAlign.remarks,
          }
              this.$http.post(this.$requestUrl.POST_BILL_ADD,obj).then((res) => {
      let result = res.data;
               
              if (200 === result.code) {
                this.dialogVisible = false
                this.$emit("Visible",false)
                this.$message({
                              type: 'success',
                              message: '修改成功!'
                          });
              } else {
                this.$message.error(result.msg)
              }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
        }else if(this.title == "添加"){
              let obj = {
              "typeNum":this.formLabelAlign.typeNum,
              "name":this.formLabelAlign.name,
              "isFixed":this.isFixedval,
              "paperSpecies":this.paperSpeciesval,
              "everyNum":this.formLabelAlign.everyNum,
              "maxMoney":this.formLabelAlign.maxMoney,
              "remarks":this.formLabelAlign.remarks,
          }
        this.$http.post(this.$requestUrl.POST_BILL_ADD,obj).then((res) => {
      let result = res.data;
               
              if (200 === result.code) {
                this.dialogVisible = false
                 this.$emit("Visible",false)
                 this.$message({
                              type: 'success',
                              message: '添加成功!'
                          });
              } else {
                this.$message.error(result.msg)
              }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
        }


    },
    getMsgFormSon(data){
        // console.log(data)
        this.optionsone = data
    },
    cs(){
    this.valueone = this.formLabelAlign.expendItem
    // this.disburseval = this.formLabelAlign.subjectAttributes
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    amend(){
    }
  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {
      // console.log(this.formLabelAlign)
    if(this.UserDisplay == 1){
        this.valueone =""
        this.disburseval =""
    }
        if(this.formLabelAlign.obj == undefined){
   let obj = {
            "typeNum":"票据类型代号",
            "name":"票据类型名称",
            "isFixed":"定额票据",
            "paperSpecies":"票据种类",
            "everyNum":"每本份数",
            "maxMoney":"最大金额",
            "remarks":"备注信息",
          }
          this.osData = []
      this.formLabelAlign.obj = obj
    }
  },
}
</script>

<style scoped lang="scss">
// .commonDialogBody {

// }
</style>